module.exports = __webpack_public_path__ + "static/media/ic_sale_manage.be53787e.svg";